import React, { useState } from "react";
import i18n from '../../../../utils/ChrI18n';

const ViewMoreDataContainer = ({ preMeetingResponsesData, postMeetingResponsesData }) => {
  const [showMoreData, setShowMoreData] = useState(false);

  const toggleMoreData = () => {
    setShowMoreData(!showMoreData);
  };

  const renderBarChartData = (responseValues) => {
    if (!responseValues || !Array.isArray(responseValues) || responseValues.length === 0) {
      return <div className="d-flex align-items-center justify-content-center text-muted"> {i18n.t('metrics.meeting_rating_responses.without_response.description')} </div>;
    }

    // Find the maximum value to calculate proportional bar widths
    const maxValue = Math.max(...responseValues.map(item => item.value || 0));

    return (
      <>
        {responseValues.map((item, index) => {
          const percentage = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
          
          return (
            <div 
              key={index} 
              className="d-flex align-items-center w-100 mb-2"
            >
              <div className="font-12 flex-shrink-0 cui-flex-2 truncate-with-ellipsis">
                {item.text} ({item.value})
              </div>
              <div className="progress progress-mini ml-2 bg-white cui-flex-5">
                <div
                  className="progress-bar progress-bar-bg rounded"
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <div className="py-4">
        <div 
          className="w-100 py-2 cui-view-more-data-container b-r-sm d-flex justify-content-center align-items-center text-muted cursor-pointer"
          onClick={toggleMoreData}
        >
          <span className="mr-1">
            {showMoreData ? 
              i18n.t("widgets.in_a_word_responses.hide_more_data") :
              i18n.t("widgets.in_a_word_responses.view_more_data")
            }
          </span>
          <i className={`fa ${showMoreData ? 'fa-chevron-up' : 'fa-chevron-down'} font-12`}></i>
        </div>
      </div>
      
      {showMoreData && (
        <div className="cui-in-a-word-responses-container">
          <div className="cui-widget-item">
            <div className='px-1'>
              {renderBarChartData(preMeetingResponsesData?.response_values)}
            </div>
          </div>
          <div className="cui-widget-separator"></div>
          <div className="cui-widget-item">
            <div className='px-1'>
              {renderBarChartData(postMeetingResponsesData?.response_values)}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ViewMoreDataContainer;